<template lang="html">
  <div>
    <MainSearch v-bind:queryParams="queryParams" v-bind:currentTab="currentTab" v-bind:fullDate="fullDate"/>
    <MainList   v-bind:queryParams="queryParams" v-bind:currentTab="currentTab" v-bind:fullDate="fullDate" v-bind:fieldobj="fieldobj"/>
  </div>
</template>

<script>

import MainSearch from '../main/component/MainSearch';
import MainList from '../main/component/MainList';

import DatePicker from 'vue2-datepicker';
import cSwitch from '../../../components/Switch';
const moment = require('moment');

export default {
  name: 'MainManagementList',
  components: {
    cSwitch,
    DatePicker,
    MainSearch,
    MainList,
  },
  props: {
    currentTab: {
      type: String,
      default: 'popup'
    },
  },
  data () {
    return {
      fullDate: [],
      datepickerLang: {
        yearFormat: "YYYY년",
        monthFormat: "M월",
        days:["일","월","화","수","목","금","토"]
      },

      queryParams: {
        banner_type     : 'popup',
        active_yn       : '',
        day_code        : '',
        start_date      : [],
        end_date        : [],
        search_type     : '',
        search_keyword  : '',
      },

      fieldobj: {
        fieldItems: [{
          'selectcheck': {
            'label': '선택', 'class': 'text-center', 'tdClass': 'text-vmiddle',
            'thStyle': {'vertical-align': 'middle'},
            'headerTitleSlot': 'selectcheck',
          }
        }, {
          'rnum': {
            'label': '번호',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle'}
          }
        }, {
          'active_yn': {
            'label': '활성화',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle'}
          }
        }, {
          'slot_number': {
            'label': '슬롯번호',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle', 'text-align': 'center', 'width':'100px'}
          }
        }, {
          'postsubject': {
            'label': '제목',
            'class': 'text-left',
            'thStyle': {'vertical-align': 'middle', 'text-align': 'center'}
          }
        }, {
          'bannerdate': {
            'label': '활성기간',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle'}
          }
        }, {
          'reg_name': {
            'label': '최총 등록자',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle'}
          }
        } , {
          'reg_date': {
            'label': '등록일',
            'class': 'text-center',
            'thStyle': {'vertical-align': 'middle'}
          }
        }],
        dateMonthButtons: [
          { item_name: '전체', item_code:'dayall', state: true },
          //{ item_name: '오늘', item_code:'-1|days',state: false },
          { item_name: '1주일', item_code:'-7|days',state: true },
          { item_name: '1개월', item_code:'-1|months',state: false },
          { item_name: '6개월', item_code:'-6|months',state: false },
          { item_name: '1년', item_code:'-1|years',state: false },
        ],
        calendarLocale: {
          "format": "YYYY-MM-DD",
          "separator": "~",
          "applyLabel": "적용",
          "cancelLabel": "취소",
          "fromLabel": "From",
          "toLabel": "To",
          "customRangeLabel": "Custom",
          "weekLabel": "W",
          "daysOfWeek": [
            "일", "월", "화", "수", "목", "금", "토"
          ],
          "monthNames": [
            "1월", "2월", "3월", "4월", "5월", "6월",
            "7월", "8월", "9월", "10월", "11월", "12월"
          ],
          "firstDay": 1
        },
      }
    }
  },
  computed: {
    listRows () {
      return this.items.length
    }
  },
  mounted: function () {

    if (this.queryParams.banner_type == 'banner01' || this.queryParams.banner_type =='banner02'){
      this.fieldobj.fieldItems = this.fieldobj.fieldItems.filter(item => !item.hasOwnProperty('slot_number'));
    }
  },

  methods: {
    getFormatDate(date) {
      if (!date) return;
      return moment(date).format("YYYY-MM-DD");
    },
  }
}


</script>



// WEBPACK FOOTER //
// src/views/site/popup/PopUpManagement.vue